// Single source of truth for the DragDrop "{{#N}}" slot contract.
// Used by the Visor (VisorBox), the editor canvas (EditorBox), and the
// CKEditor widget so all three stay in sync. Do NOT change the {{#N}}
// wire format without updating the Visor scoring contract.

export const SLOT_RE = /\{\{#(\d+)\}\}/g;

export function countSlots(html) {
  if (!html || typeof html !== "string") return 0;
  const m = html.match(SLOT_RE);
  return m ? m.length : 0;
}

// Returns an ordered array of { type: "text", value } | { type: "slot", index }.
export function splitSlots(html) {
  if (!html || typeof html !== "string") return [{ type: "text", value: html || "" }];
  const out = [];
  let last = 0;
  const re = new RegExp(SLOT_RE.source, "g");
  let m;
  while ((m = re.exec(html)) !== null) {
    out.push({ type: "text", value: html.slice(last, m.index) });
    out.push({ type: "slot", index: parseInt(m[1], 10) });
    last = m.index + m[0].length;
  }
  out.push({ type: "text", value: html.slice(last) });
  return out;
}

// Rewrites slot markers to be sequential (1..N) in document order.
export function renumberSlots(html) {
  if (!html || typeof html !== "string") return html;
  let n = 0;
  return html.replace(SLOT_RE, () => `{{#${++n}}}`);
}
